<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-primary.new-validation-response-button(:to="{ name: 'atiNew' }")
        i.fa.fa-plus
        span.ml5 New
    DataGrid(ref="grid" :fetch="fetchData" url-page-param="page")
      tr(slot="thead")
        th Name
        th Type
        th Translations
        th
      tr(v-for="(i, index) in atis", :id="'ati-tableid-' + index")
        td {{i.name}}
        td {{i.type | atiMessageTypeFilter}}
        td {{i.translationsList}}
        td.actions
          router-link.btn-edit(title="Edit" :to="{ name: 'atiEdit', params: { id: i.id }}")
          a.btn-trash(title="Delete" @click="deleteAti(i.id)")

</template>
<script>
import miniToastr from 'mini-toastr'
import DataGrid from '@/components/ssp/DataGrid'
import Core from '@/service/apis/Core'
import { atiMessageTypeFilter } from '@/filters/filters'

export default {
  data: () => ({
    errorMsg: null,
    atis: []
  }),
  methods: {
    fetchData(page) {
      return Core.listAtis(page.maxOffsetRequest())
        .then((r) => {
          const atis = r.data.ati.map((a) => {
            const ati = a
            ati.translationsList = ati.translations.translation.map((translation) => translation.country).join(', ')
            return ati
          })
          this.atis = atis
          return r.data.totalRecords
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    deleteAti(id) {
      this.$confirm({ text: 'Are you sure you want to delete this validation response message?' })
        .then((conf) => {
          if (conf) {
            Core.removeAti(id)
              .then(() => {
                miniToastr.success('Validation response message was deleted')
                this.$refs.grid.reload()
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    },
  },
  components: {
    DataGrid
  },
  filters: {
    atiMessageTypeFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/ati/Atis.vue